const terms_html = `
            <title>Website Terms and Conditions</title>
            <style type="text/css">
            @page{margin:90px 50px 50px;@prince-overlay{content:flow(watermark)}@top{content:flow(header);vertical-align:bottom;padding:50px 0 20px}@bottom{content:flow(footer);margin-bottom:30px}@bottom-left{content:string(copyText, last);width:0;overflow:visible;white-space:nowrap;font-family:myriad-pro,sans-serif;font-size:9pt;color:#bcbec0}}@page :first{margin-top:50px;@top{content:flow(firstHeader)}@bottom{content:flow(firstFooter);margin-bottom:30px}}.templated .imageList{display:block;margin-left:-25px;margin-bottom:30px}.templated .imageList .imageAndData{display:inline-block;vertical-align:top;margin-left:25px;margin-top:30px}.templated .imageList .imageAndData .imageWrapper{display:flex;align-items:center;justify-content:center}.templated .imageList .imageAndData .imageWrapper img{max-width:100%;max-height:100%}.templated .imageList .imageAndData .comment{display:block;overflow-wrap:break-word}.templated .copyright{visibility:hidden;height:0;string-set:copyText content()}.templated .currentPageNum{content:counter(page)}.templated .totalPageNum{content:counter(pages)}.templated .header{flow:static(header)}.templated .firstHeader{flow:static(firstHeader)}.templated .footer{flow:static(footer)}.templated .firstFooter{flow:static(firstFooter)}.templated .printWatermark{flow:static(watermark)}.templated .pageBreak{page-break-before:always;display:block}.templated .blankLine{display:block;border-bottom:1px solid #000}.templated .keepTogether,.templated .signatureEntity{page-break-inside:avoid}.templated .outputDocument{counter-reset:page 1 pages 1;prince-page-group:start;string-set:copyText ""}.templated li ol:first-child,.templated li ol:first-child>li:first-child,.templated li ul:first-child,.templated li ul:first-child>li:first-child{margin-top:0}.templated .inlineLogoHeader{display:flex;margin-bottom:30px;align-items:center;justify-content:center}.templated .inlineLogoHeader .imageList,.templated .inlineLogoHeader .imageAndData,.templated .inlineLogoHeader .keepTogether p:last-child{margin:0}.templated .inlineLogoHeader .imageWrapper{padding-right:25px}.sm .templated .imageList{margin-bottom:15px}.sm .templated .imageList div{margin-top:15px}@media screen{.templated .header,.templated .footer,.templated .firstHeader,.templated .firstFooter,.templated .copyright,.templated .printWatermark{display:none}}@media print{.LDCopyright,.watermark{display:none}}

@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  src: url(https://www.lawdepot.com/common/fonts/Lato/Lato-Regular.eot);
  src: local('Lato Regular'), local('Lato-Regular'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Regular.woff2) format('woff2'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Regular.woff) format('woff'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Regular.svg#Lato) format('svg'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Regular.ttf) format('truetype'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Regular.eot?#iefix) format('embedded-opentype');
  font-display: block;
}

@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 700;
  src: url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold.eot);
  src: local('Lato Bold'), local('Lato-Bold'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold.woff2) format('woff2'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold.woff) format('woff'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold.ttf) format('truetype'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold.eot?#iefix) format('embedded-opentype');
  font-display: block;
}

@font-face {
  font-family: 'Lato';
  font-style: normal;
  font-weight: 900;
  src: url(https://www.lawdepot.com/common/fonts/Lato/Lato-Black.eot);
  src: local('Lato Black'), local('Lato-Black'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Black.woff2) format('woff2'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Black.woff) format('woff'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Black.ttf) format('truetype'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Black.eot?#iefix) format('embedded-opentype');
  font-display: block;
}

@font-face {
  font-family: 'Lato';
  font-style: italic;
  font-weight: 400;
  src: url(https://www.lawdepot.com/common/fonts/Lato/Lato-Italic.eot);
  src: local('Lato Italic'), local('Lato-Italic'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Italic.woff2) format('woff2'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Italic.woff) format('woff'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Italic.ttf) format('truetype'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Italic.eot?#iefix) format('embedded-opentype');
  font-display: block;
}

@font-face {
  font-family: 'Lato';
  font-style: italic;
  font-weight: 700;
  src: url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold-Italic.eot);
  src: local('Lato Bold Italic'), local('Lato-BoldItalic'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold-Italic.woff2) format('woff2'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold-Italic.woff) format('woff'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold-Italic.ttf) format('truetype'), url(https://www.lawdepot.com/common/fonts/Lato/Lato-Bold-Italic.eot?#iefix) format('embedded-opentype');
  font-display: block;
}
@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 300;
  src: url(/common/fonts/Open-Sans/opensans-light.eot);
  src: local('Open-Sans Light'), local('OpenSans-Light'), url(/common/fonts/Open-Sans/opensans-light.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-light.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-light.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-light.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-light.svg#opensans-light) format('svg');
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  src: url(/common/fonts/Open-Sans/opensans-regular.eot);
  src: local('Open-Sans Regular'), local('OpenSans-Regular'), url(/common/fonts/Open-Sans/opensans-regular.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-regular.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-regular.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-regular.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-regular.svg#opensans-regular) format('svg');
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  src: url(/common/fonts/Open-Sans/opensans-semibold.eot);
  src: local('Open-Sans SemiBold'), local('OpenSans-SemiBold'), url(/common/fonts/Open-Sans/opensans-semibold.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-semibold.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-semibold.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-semibold.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-semibold.svg#opensans-semibold) format('svg');
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 700;
  src: url(/common/fonts/Open-Sans/opensans-bold.eot);
  src: local('Open-Sans Bold'), local('OpenSans-Bold'), url(/common/fonts/Open-Sans/opensans-bold.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-bold.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-bold.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-bold.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-bold.svg#opensans-bold) format('svg');
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 800;
  src: url(/common/fonts/Open-Sans/opensans-extrabold.eot);
  src: local('Open-Sans Extra Bold'), local('OpenSans-ExtraBold'), url(/common/fonts/Open-Sans/opensans-extrabold.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-extrabold.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-extrabold.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-extrabold.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-extrabold.svg#opensans-extrabold) format('svg');
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 300;
  src: url(/common/fonts/Open-Sans/opensans-lightitalic.eot);
  src: local('Open-Sans Light Italic'), local('OpenSansLight-Italic'), url(/common/fonts/Open-Sans/opensans-lightitalic.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-lightitalic.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-lightitalic.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-lightitalic.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-lightitalic.svg#opensans-lightitalic) format('svg');
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 400;
  src: url(/common/fonts/Open-Sans/opensans-italic.eot);
  src: local('Open-Sans Italic'), local('OpenSans-Italic'), url(/common/fonts/Open-Sans/opensans-italic.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-italic.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-italic.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-italic.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-italic.svg#opensans-italic) format('svg');
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 600;
  src: url(/common/fonts/Open-Sans/opensans-semibolditalic.eot);
  src: local('Open-Sans SemiBold Italic'), local('OpenSansSemiBold-Italic'), url(/common/fonts/Open-Sans/opensans-semibolditalic.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-semibolditalic.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-semibolditalic.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-semibolditalic.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-semibolditalic.svg#opensans-semibolditalic) format('svg');
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 700;
  src: url(/common/fonts/Open-Sans/opensans-bolditalic.eot);
  src: local('Open-Sans Bold Italic'), local('OpenSansBold-Italic'), url(/common/fonts/Open-Sans/opensans-bolditalic.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-bolditalic.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-bolditalic.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-bolditalic.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-bolditalic.svg#opensans-bolditalic) format('svg');
  font-display: swap;
}

@font-face {
  font-family: 'Open Sans';
  font-style: italic;
  font-weight: 800;
  src: url(/common/fonts/Open-Sans/opensans-extrabolditalic.eot);
  src: local('Open-Sans ExtraBold Italic'), local('OpenSansExtraBold-Italic'), url(/common/fonts/Open-Sans/opensans-extrabolditalic.woff2) format('woff2'), url(/common/fonts/Open-Sans/opensans-extrabolditalic.woff) format('woff'), url(/common/fonts/Open-Sans/opensans-extrabolditalic.ttf) format('truetype'), url(/common/fonts/Open-Sans/opensans-extrabolditalic.eot?#iefix) format('embedded-opentype'), url(/common/fonts/Open-Sans/opensans-extrabolditalic.svg#opensans-extrabolditalic) format('svg');
  font-display: swap;
}
@page{margin:60px 35px 35px}@page :first{margin-top:35px}.template_test{font-family:"Lato";font-size:10pt}.template_test .pageBreak{page-break-before:always}.template_test .blankLine{display:block;border-bottom:1px solid #000}.template_test .keepTogether{page-break-inside:avoid}.template_test h1{font-size:22pt;text-align:center;padding:15px 0;margin:15px 0;border-bottom:2px solid #000;font-weight:900}.template_test h2{text-align:center;font-size:14pt;text-transform:uppercase;font-weight:700;overflow:hidden;margin:20px 0}.template_test h2::before,.template_test h2::after{background-color:#000;content:"";display:inline-block;height:1px;position:relative;vertical-align:middle;width:50%}.template_test h2::before{right:10px;margin-left:-50%}.template_test h2::after{left:10px;margin-right:-50%}.template_test .contactInfo{text-align:center;margin:15px 0}.template_test .contactInfo span::before{content:" | ";padding:0 5px}.template_test .contactInfo span:first-child::before{content:"";padding:0}.template_test p{margin:20px 0}.template_test .infoHeading{margin:20px 0 10px;position:relative}.template_test .infoHeading .mainTitle,.template_test .infoHeading .mainInfo{font-weight:900;font-size:12pt;display:block;max-width:50%}.template_test .infoHeading .subTitle,.template_test .infoHeading .subInfo{font-weight:700;font-size:11pt;display:block;max-width:50%}.template_test .infoHeading .mainInfo{position:absolute;top:0;right:0}.template_test .infoHeading .subInfo{position:absolute;bottom:0;right:0}.template_test .infoHeading.education .subInfo{font-weight:normal;font-style:italic;position:static;display:block;font-size:10pt;max-width:100%}.template_test .infoHeading.award .subInfo,.template_test .infoHeading.volunteer .subInfo{font-weight:normal;position:static;display:block;font-size:10pt;max-width:100%}.template_test ul{margin:0;list-style-type:none}.template_test ul li::before{content:"â€¢";position:absolute;left:20px}.template_test li{margin:10px 0;padding-left:33px;position:relative;box-sizing:border-box}.template_test .columns{font-size:0}.template_test .columns li{display:inline-block;width:50%;font-size:10pt;margin:5px 0;vertical-align:top}.template_test .workSample{margin-left:20px}.ua-mobile .template_test h2::before,.ua-mobile .template_test h2::after{height:2px}.ua-android.ua-webkit .template_test .columns{font-size:10pt}.ua-android.ua-webkit .template_test .columns li{width:49%}
body, html {
	background: #FFF;
}
noscript,#navigation,#banner,#footer,#intro,#outtro,.ImportantInfoDialog,
.headerSimplePreview, .sectionMenuTop, .selLicense, .previewHead,
iframe, iframe *, .noMobile, .woahbar, .contractFootControls, .previewFormatWarning {
	display:none;
}
#upsell, #popupContainer, #popupMask, .contentBreak, .contentBreakEnd {
   display:none !important;
}
#popupContainer, #popupMask {
	visibility: hidden;
}
#wrapper,#content {
   background:none;
	position:relative;
	display:block;
	width:auto;
}
#outputPage {
	display:block;
	padding:3px;
	background:#FFF;
	color:#000;
	position:relative;
	mso-style-parent:"";
	margin:0;
	margin-bottom:0.0001pt;
	mso-pagination:widow-orphan;
	tab-stops:-.5in;
	font-size:12pt;
	font-family:"Times New Roman", serif;
	mso-fareast-font-family:"Times New Roman";
	line-height: 18pt;
}
#outputPage {
   width:100%;
   background:none;
}
#outputPage table{border-collapse:collapse}
#outputPage ol { list-style:decimal;}
#outputPage ol ol { list-style:lower-alpha;}
#outputPage ol ol ol { list-style:lower-roman;}
#outputPage ol ol ol ol { list-style:decimal; list-style-position: inherit; }
#outputPage br.pageBreak{page-break-before:always}
 
@media screen {
	#outputPage br.pageBreak{display:none}	
} 
#outputPage .outputVersion2 p,#outputPage .outputVersion2 ol,#outputPage .outputVersion2 ul,#outputPage .outputVersion2 table{margin-bottom:0}
#outputPage .outputVersion2 ol,#outputPage .outputVersion2 ul{margin-left:0;padding-left:0}
#outputPage .outputVersion2 li > div{display:table;*display:inline;*margin-left:-17px}
#outputPage .format-doc .outputVersion2 li,
#outputPage .format-rtf .outputVersion2 li,
#outputPage .format-docx .outputVersion2 li,
#outputPage .format-pdf .outputVersion2 li {margin-left:18pt}
#outputPage .outputVersion2{padding-top:43pt}
.LDCopyright {
	font-size:67%;
}
.LDCellCenter {
	text-align:center;
}
.LDCellPadLeft {
	padding-left:100px;
}
.LDCellRight {
	text-align:right;
}
.LDResRentalBox {
   width:100%;
}
.LDQuitclaimHead {
   height:3in;
}
.LDWarrantyHead {
   height:3in;
}
.LDQuitclaimHeadCA {
   height:1in;
}
.LDWarrantyHeadCA {
   height:1in;
}
.LDWarrantyHeadMO {
   height:2in;
}
.LDQuitclaimHeadMO {
   height:2in;
}
.SubHeadStyle {
	font-weight:bold;
	text-decoration:underline;
}
.SectionTitle{
   font-weight:bold;
   text-decoration:underline;
   margin:1em 0;
}
.invoiceBorder {
   border:1px solid #000;
}
.invoiceGreyBG {
   background-color:#ccc;
}
.LDBold {
   font-weight:bold;
}
.LDBackgroundOL {
	list-style-type:upper-alpha;
}
#bottomTabs, #topTabs, #introContent, #loadingIndicator, #questionpage, #documentControls, #questionpage { display:none }
#productContent, #documentContent { width:100%;border:0;margin:0 }
#outputPage li{
   margin-bottom:1em;
}
#outputPage li li{
   margin-bottom:1em;
}

#outputPage li ol {
	margin-top: 1em;
}
#outputPage li ol li {
	margin-bottom: 1em;
}
#outputPage li.lh,#outputPage li.lhl {
	margin-bottom: 0;
	list-style: none;
}
.FirstMajorListHeading { 
	font-weight:bold;
	margin-bottom:1.6em;
}
.FirstListHeading {
	font-weight: bold;
	text-decoration: underline;
	font-size:12pt;
	margin:1.4em 0 0.2em 2em; /* 2em should be set to left margin of lists */
}
.ListHeading {
	font-weight: bold;
	text-decoration: underline;
}

 div.header,
 div.firstHeader,
 div.footer,
 div.firstFooter{ display: none;}

 .blankLine {
	display: block;
	border-bottom: solid 1px #000;
}



/* End Alerts/Confirms Inline Dialogs */
/* Mobile Scrollbars */
.ua-mobile .contractbody::-webkit-scrollbar,
.ua-mobile #contractbody::-webkit-scrollbar,
.ua-mobile .groupNavigationInner > ul::-webkit-scrollbar,
.ua-mobile #contentTopInnerDisclaimer::-webkit-scrollbar,
.ua-mobile #contentTopInnerPrivacy::-webkit-scrollbar,
.ua-mobile #contentTopInnerEditorialPolicy::-webkit-scrollbar,
.ua-mobile #contentTopInnerTerms::-webkit-scrollbar,
.ua-mac_os_x .contractbody::-webkit-scrollbar,
.ua-mac_os_x #contractbody::-webkit-scrollbar,
.ua-mac_os_x .groupNavigationInner > ul::-webkit-scrollbar,
.ua-mac_os_x #contentTopInnerDisclaimer::-webkit-scrollbar,
.ua-mac_os_x #contentTopInnerPrivacy::-webkit-scrollbar,
.ua-mac_os_x #contentTopInnerEditorialPolicy::-webkit-scrollbar,
.ua-mac_os_x #contentTopInnerTerms::-webkit-scrollbar,
.ua-mobile #DIVContractList::-webkit-scrollbar,
.mac_os_x #DIVContractList::-webkit-scrollbar,
.ua-mobile #tip::-webkit-scrollbar,
.ua-mac_os_x #tip::-webkit-scrollbar,
.ua-mac_os_x ul.ui-autocomplete::-webkit-scrollbar,
.ua-mobile ul.ui-autocomplete::-webkit-scrollbar,
.ua-mobile:not(.ua-ios) .inlineFooterDialog .ui-dialog-content::-webkit-scrollbar,
.addRecipientDialog::-webkit-scrollbar
{
   -webkit-appearance: none;
   width: 7px;
}
.ua-mobile .contractbody::-webkit-scrollbar-thumb,
.ua-mobile #contractbody::-webkit-scrollbar-thumb,
.ua-mobile .groupNavigationInner > ul::-webkit-scrollbar-thumb,
.ua-mobile #contentTopInnerDisclaimer::-webkit-scrollbar-thumb,
.ua-mobile #contentTopInnerPrivacy::-webkit-scrollbar-thumb,
.ua-mobile #contentTopInnerEditorialPolicy::-webkit-scrollbar-thumb,
.ua-mobile #contentTopInnerTerms::-webkit-scrollbar-thumb,
.ua-mac_os_x .contractbody::-webkit-scrollbar-thumb,
.ua-mac_os_x #contractbody::-webkit-scrollbar-thumb,
.ua-mac_os_x .groupNavigationInner > ul::-webkit-scrollbar-thumb,
.ua-mac_os_x #contentTopInnerDisclaimer::-webkit-scrollbar-thumb,
.ua-mac_os_x #contentTopInnerPrivacy::-webkit-scrollbar-thumb,
.ua-mac_os_x #contentTopInnerEditorialPolicy::-webkit-scrollbar-thumb,
.ua-mac_os_x #contentTopInnerTerms::-webkit-scrollbar-thumb,
.ua-mac_os_x #DIVContractList::-webkit-scrollbar-thumb,
.ua-mobile #DIVContractList::-webkit-scrollbar-thumb,
.ua-mobile #tip::-webkit-scrollbar-thumb, 
.ua-mac_os_x #tip::-webkit-scrollbar-thumb,
.ua-mac_os_x ul.ui-autocomplete::-webkit-scrollbar-thumb,
.ua-mobile ul.ui-autocomplete::-webkit-scrollbar-thumb,
.ua-mobile:not(.ua-ios) .inlineFooterDialog .ui-dialog-content::-webkit-scrollbar-thumb,
.addRecipientDialog::-webkit-scrollbar-thumb
{
   border-radius: 4px;
   background-color: rgba(0,0,0,.5);
   -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
}
/* End special links */
/* General DCS Output Styles */
body li>ol:first-child, body li>ul:first-child {margin-top:0;}
.ua-edge body li>ol:first-child, .ua-edge body li>ul:first-child, .ua-ie body li>ol:first-child, .ua-ie body li>ul:first-child  {margin-top:-24px;}
body li ol, body li ul {
   margin-top:1em;
}
body li{
   margin-bottom:1em;
}
body li.lh,body li.lhl{
   margin-bottom:0;
}
body th{font-weight:normal;}
body td>p:first-child, body th>p:first-child {margin-top:0}
body td>p:last-child, body th>p:last-child {margin-bottom:0}
body br.pageBreak{display:none}
body .blankLine {display:block; border-bottom:solid 1px black;}body ol,body ul{margin-left:0;padding-left:0}body .header,body .footer,body .firstHeader,body .firstFooter,body .printWatermark{display:none}body li{padding-left:25px;margin-left:15px}body #outputPage,body .documentContent,body .contract{padding:2em;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;overflow-x:hidden}body .outputVersion2 li.lhl{display:block}body .outputVersion2 ol ol{list-style:lower-alpha}body .outputVersion2 ol ol ol{list-style:lower-roman}body .outputVersion2 li>div{display:table;margin:0 !important;padding:0 !important}.LD body #contractbody li,.LD body .contractbody li{padding-left:25px;margin-left:30px}body .outputVersion1:not(.templated) *,body .outputVersion2:not(.templated) *{font-family:"Times New Roman",serif;font-size:12pt;line-height:18pt}body .outputVersion1:not(.templated) * ul,body .outputVersion2:not(.templated) * ul{list-style:disc}body .outputVersion1:not(.templated) * .lh,body .outputVersion1:not(.templated) * .lhl,body .outputVersion2:not(.templated) * .lh,body .outputVersion2:not(.templated) * .lhl{list-style:none}body .outputVersion1:not(.templated) * strong,body .outputVersion2:not(.templated) * strong{font-weight:700}
			
            @media only screen and (max-device-width: 1024px) {body{ -webkit-text-size-adjust:100%; -moz-text-size-adjust:100%; -ms-text-size-adjust:100%; }}</style>
            </head>
            <body>
            <div id="outputPage" class="ContractText">
            <div class="format-html">
		<div data-exp="simple2" class="outputVersion1">
			<div class=" header">
	<span style="line-height:18.0pt;" class="content">Website Terms and Conditions</span>
	<span style="line-height:18.0pt;" class="pageNumbers">Page <span class="currentPageNum"></span> of <span class="totalPageNum"></span></span></div><div class=" footer"></div><div class=" firstHeader"></div><div class=" firstFooter">
	<span style="line-height:18.0pt;" class="pageNumbers">Page <span class="currentPageNum"></span> of <span class="totalPageNum"></span></span></div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Center;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">TERMS AND CONDITIONS</span>
	</p>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">These terms and conditions (the "Terms and Conditions") govern the use of <span style="font-style:normal;font-weight:bold;">http://argumentation.io</span> (the "Site"). This Site is owned and operated by Argumentation LLC. This Site is a saas subscription.<br><br>By using this Site, you indicate that you have read and understand these Terms and Conditions and agree to abide by them at all times.<br><br>THESE TERMS AND CONDITIONS CONTAIN A DISPUTE RESOLUTION CLAUSE THAT IMPACTS YOUR RIGHTS ABOUT HOW TO RESOLVE DISPUTES. PLEASE READ IT CAREFULLY.
	</p><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Intellectual Property</span><br>All content published and made available on our Site is the property of Argumentation LLC and the Site's creators. This includes, but is not limited to images, text, logos, documents, downloadable files and anything that contributes to the composition of our Site.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">User Contributions</span><br>Users may post the following information on our Site:
	</p>
	<ul style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;list-style:disc;">
		<li style="margin-bottom:0.0pt;" value="1"><span>Diagrams containing text.</span><span style="color:#000000;"><br></span>
		</li>
	</ul>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">By posting publicly on our Site, you agree not to act illegally or violate these Terms and Conditions.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Accounts</span><br>When you create an account on our Site, you agree to the following:
	</p>
	<ol start="1" style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;list-style:decimal;">
		<li style="margin-bottom:18.0pt;" value="1"><span>You are solely responsible for your account and the security and privacy of your account, including passwords or sensitive information attached to that account; and</span><span style="color:#000000;"><br></span>
		</li>
		<li style="margin-bottom:0.0pt;" value="2"><span>All personal information you provide to us through your account is up to date, accurate, and truthful and that you will update your personal information if it changes.</span><span style="color:#000000;"><br></span>
		</li>
	</ol>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">We reserve the right to suspend or terminate your account if you are using our Site illegally or if you violate these Terms and Conditions.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Sale of Goods</span><br>These Terms and Conditions govern the sale of goods available on our Site.
	</p>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">The following goods are available on our Site:
	</p>
	<ul style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;list-style:disc;">
		<li style="margin-bottom:0.0pt;" value="1"><span>Subscriptions.</span><span style="color:#000000;"><br></span>
		</li>
	</ul>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">These Terms and Conditions apply to all the goods that are displayed on our Site at the time you access it. This includes all products listed as being out of stock. All information, descriptions, or images that we provide about our goods are as accurate as possible. However, we are not legally bound by such information, descriptions, or images as we cannot guarantee the accuracy of all goods we provide. You agree to purchase goods from our Site at your own risk.
	</p>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">We reserve the right to modify, reject or cancel your order whenever it becomes necessary. If we cancel your order and have already processed your payment, we will give you a refund equal to the amount you paid. You agree that it is your responsibility to monitor your payment instrument to verify receipt of any refund.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">User Goods and Services</span><br>Our Site allows users to sell goods and services. We do not assume any responsibility for the goods and services users sell on our Site. We cannot guarantee the quality or accuracy of any goods and services sold by users on our Site. However, if we are made aware that a user is violating these Terms and Conditions, we reserve the right to suspend or prohibit the user from selling goods and services on our Site.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Subscriptions</span><br>Your subscription automatically renews and you will be automatically billed until we receive notification that you want to cancel the subscription.
	</p>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">To cancel your subscription, please follow these steps: Subscribers can cancel their subscriptions by selecting "Manage Account" from the Main Menu and following the instructions. If a customer cancels their subscription, they will not be billed again.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Payments</span><br>We accept the following payment methods on our Site:
	</p>
	<ul style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;list-style:disc;">
		<li style="margin-bottom:18.0pt;" value="1"><span>Credit Card;</span><span style="color:#000000;"><br></span>
		</li>
		<li style="margin-bottom:18.0pt;" value="2"><span>Bank; and</span><span style="color:#000000;"><br></span>
		</li>
		<li style="margin-bottom:0.0pt;" value="3"><span>Google Pay.</span><span style="color:#000000;"><br></span>
		</li>
	</ul>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">When you provide us with your payment information, you authorize our use of and access to the payment instrument you have chosen to use. By providing us with your payment information, you authorize us to charge the amount due to this payment instrument.<br><br>If we believe your payment has violated any law or these Terms and Conditions, we reserve the right to cancel or reverse your transaction.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Consumer Protection Law</span><br>Where any consumer protection legislation in your jurisdiction applies and cannot be excluded, these Terms and Conditions will not limit your legal rights and remedies under that legislation. These Terms and Conditions will be read subject to the mandatory provisions of that legislation. If there is a conflict between these Terms and Conditions and that legislation, the mandatory provisions of the legislation will apply.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Limitation of Liability</span><br>Argumentation LLC and our directors, officers, agents, employees, subsidiaries, and affiliates will not be liable for any actions, claims, losses, damages, liabilities and expenses including legal fees from your use of the Site.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Indemnity</span><br>Except where prohibited by law, by using this Site you indemnify and hold harmless Argumentation LLC and our directors, officers, agents, employees, subsidiaries, and affiliates from any actions, claims, losses, damages, liabilities and expenses including legal fees arising out of your use of our Site or your violation of these Terms and Conditions.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Applicable Law</span><br>These Terms and Conditions are governed by the laws of the State of Texas.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Dispute Resolution</span><br>Subject to any exceptions specified in these Terms and Conditions, if you and Argumentation LLC are unable to resolve any dispute through informal discussion, then you and Argumentation LLC agree to submit the issue first before a non-binding mediator and to an arbitrator in the event that mediation fails. The decision of the arbitrator will be final and binding. Any mediator or arbitrator must be a neutral party acceptable to both you and Argumentation LLC. The costs of any mediation or arbitration will be shared equally between you and Argumentation LLC.
	</p>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">Notwithstanding any other provision in these Terms and Conditions, you and Argumentation LLC agree that you both retain the right to bring an action in small claims court and to bring an action for injunctive relief or intellectual property infringement. 
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Severability</span><br>If at any time any of the provisions set forth in these Terms and Conditions are found to be inconsistent or invalid under applicable laws, those provisions will be deemed void and will be removed from these Terms and Conditions. All other provisions will not be affected by the removal and the rest of these Terms and Conditions will still be considered valid.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Changes</span><br>These Terms and Conditions may be amended from time to time in order to maintain compliance with the law and to reflect any changes to the way we operate our Site and the way we expect users to behave on our Site. We will notify users by email of changes to these Terms and Conditions or post a notice on our Site.
	</p></div><div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;"><span style="font-style:normal;font-weight:bold;text-decoration:underline;">Contact Details</span><br>Please contact us if you have any questions or concerns. Our contact details are as follows:<br><br>(141) 247-2011<br>argumentationcompany@gmail.com<br>5913 Red Bud Ridge Lane
	</p>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Left;">You can also contact us through the feedback form available on our Site.
	</p></div>
	<p style="line-height:18.0pt;font-size:12.0pt;line-height:18.0pt;font-family:Times New Roman;color:#000000;text-align:Right;">Effective Date: 12th day of April, 2024
	</p><div class="LDCopyright">
				<p>&copy;2002-2024 LawDepot.com&reg;</p>
			</div>
		</div>
	</div>
            </div>
`

export const Terms = () => <div dangerouslySetInnerHTML={{ __html: terms_html }} />